import { Row, Col, Form, Input, Space } from "antd";

import { AttachFile, DatePicker } from "../../../../../../../components";
import { AiOutlineCloudUpload } from "react-icons/ai";
// import { Moment } from "moment";
// import { useState } from "react";
// import { RangePickerProps } from "antd/es/date-picker";

interface Props {
  userInfo?: any;
}

const { RangePicker } = DatePicker;

export const AccidentLetterForm = ({ userInfo }: Props) => {
  const form = Form.useFormInstance();
  // const [dates, setDates] = useState<[Moment, Moment] | null>(null);

  const onCalendarChange = (dates: any) => {
    // setDates(dates);
    if (dates && dates[1]) {
      const endDate = dates[1];
      const eExpectedReturnDate = endDate.clone().add(1, "day").endOf("day");
      form.setFieldValue("eExpectedReturnDate", eExpectedReturnDate);
    }
  };

  // const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  //   if (!userInfo?.paidLeave_Remain) return true;
  //   if (!current || !dates) return false;
  //   const startDate = dates[0];
  //   const eightDaysFromNow = startDate
  //     .clone()
  //     .add(Math.ceil(userInfo?.paidLeave_Remain), "day")
  //     .startOf("day");
  //   return current && current > eightDaysFromNow;
  // };

  return (
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Form.Item name="eFileContent">
          <AttachFile>
            <Space style={{ fontSize: 15 }}>
              Chứng từ đính kèm
              <AiOutlineCloudUpload size={24} />
              (word, excel, pdf, jpg,...)
            </Space>
          </AttachFile>
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Thời gian xin nghỉ phép"
          name="eVacationPeriod"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn trường này!",
            },
          ]}
        >
          <RangePicker
            className="min-w-full"
            onCalendarChange={onCalendarChange}
            // disabledDate={disabledDate}
          />
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Thời gian (dự kiến) trở lại làm việc"
          name="eExpectedReturnDate"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn trường này!",
            },
          ]}
        >
          <DatePicker className="min-w-full" />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item
          label="Lý do"
          name="eReason"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập trường này!",
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>
      </Col>
    </Row>
  );
};
